import React, { useContext } from 'react'
import { IconMoonFilled, IconSunFilled } from '@tabler/icons-react'
import { ThemeContext } from 'theme/ThemeProvider'
import styled from 'styled-components'
import { useThemeStore } from 'app/hooks'

const DarkModeToggle = () => {
	const { isDarkMode, toggleTheme, theme } = useContext(ThemeContext)

	const icon = isDarkMode ? (
		<IconSunFilled size={18} />
	) : (
		<IconMoonFilled size={18} />
	)

	return (
		<ToggleButton
			isDarkMode={isDarkMode}
			pointColor={theme?.COLORS?.point}
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
				toggleTheme()
			}}>
			{icon}
		</ToggleButton>
	)
}

const ToggleButton = styled.button<{ isDarkMode?: boolean; pointColor?: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 8px;
	border: none;
	background: transparent;
	color: ${props => props.theme.COLORS.textw};
	cursor: pointer;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;

	&:hover {
		background: ${props => props.pointColor ? props.pointColor + '20' : 'rgba(0, 0, 0, 0.1)'};
		color: ${props => props.pointColor || props.theme.COLORS.point};
		transform: translateY(-1px);
	}

	&:active {
		transform: scale(0.95);
	}

	svg {
		transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	}

	&:hover svg {
		transform: rotate(${props => props.isDarkMode ? '-20deg' : '20deg'});
	}

	@media (max-width: 1200px) {
		width: 28px;
		height: 28px;

		svg {
			width: 16px;
			height: 16px;
		}
	}

	@media (max-width: 900px) {
		width: 26px;
		height: 26px;

		svg {
			width: 15px;
			height: 15px;
		}
	}
`

export default DarkModeToggle
